import axios from "axios";
import { Navigate } from "react-router-dom";

// const API_URL = "http://localhost:8000/";
const API_URL = process.env.REACT_APP_API_URL || "https://azmrehabcentre.pk/api/public";

const login = (values) => {
    const headers = {
        "Content-Type": "application/json",
    };

    console.log("Sending login request to:", `${API_URL}/signin`);

    return axios.post(
        `${API_URL}/signin`,
        {
            username: values.username,
            password: values.password,
        },
        {
            headers: headers,
        }
    ).then(response => {
        console.log("Login response received:", response);
        return response;
    }).catch(error => {
        console.error("Login error:", error);
        throw error;
    });
}

const getContactMessages = () => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.get(
        `${API_URL}/contact-messages`,
        {
            headers: headers,
        }
    );
};

const addDoctor = (values) => {
    // Create FormData from values object
    const formData = new FormData();

    // Debug: Log what values we received
    console.log('=== Values received in service ===');
    console.log(values);
    console.log('================================');

    // Only append non-empty values
    if (values.name && values.name.trim()) {
        formData.append('name', values.name.trim());
    }

    if (values.designation && values.designation.trim()) {
        formData.append('designation', values.designation.trim());
    }

    if (values.specialization && values.specialization.trim()) {
        formData.append('specialization', values.specialization.trim());
    }

    if (values.degrees && values.degrees.trim()) {
        formData.append('degrees', values.degrees.trim());
    }

    if (values.gender && values.gender.trim()) {
        formData.append('gender', values.gender.trim());
    }

    // Handle image file if present
    if (values.image && values.image instanceof File) {
        formData.append('image', values.image);
    }

    // Debug: Log what we're actually sending
    console.log('=== FormData Contents ===');
    for (let [key, value] of formData.entries()) {
        if (value instanceof File) {
            console.log(`${key}: [File] ${value.name} (${value.size} bytes)`);
        } else {
            console.log(`${key}: "${value}"`);
        }
    }
    console.log('========================');

    return axios.post(
        `${API_URL}/doctors`,
        formData,
        {
            headers: {
                "Accept": "application/json",
                "Content-Type": "multipart/form-data",
            },
        }
    )
        .then(response => {
            console.log('Add doctor response:', response.data);
            return response.data;
        })
        .catch(error => {
            console.error('Error adding doctor:', error.response?.data || error.message);
            throw error;
        });
};

const deleteDoctor = (id) => {
    console.log('Attempting to delete doctor with ID:', id);

    // Get auth token if you're using authentication
    const authToken = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');

    const headers = {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest", // Important for Laravel
    };

    // Add authorization header if token exists
    if (authToken) {
        headers["Authorization"] = `Bearer ${authToken}`;
    }

    // Add CSRF token if available
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    if (csrfToken) {
        headers["X-CSRF-TOKEN"] = csrfToken;
    }

    return axios.delete(
        `${API_URL}/doctors/${id}`,
        {
            headers: headers,
        }
    )
        .then(response => {
            console.log('Delete doctor response:', response);
            return response;
        })
        .catch(error => {
            console.error('Error deleting doctor:', error.response?.data || error.message);
            throw error;
        });
};


// ===== FRONTEND SERVICE FUNCTION (FIXED) =====

const addStaff = async (staffData, adminId) => {
    try {
        let formData;

        // Check if staffData is already FormData
        if (staffData instanceof FormData) {
            formData = staffData;
            // Ensure admin_id is added if not already present
            if (!formData.has('admin_id')) {
                formData.append('admin_id', adminId);
            }
        } else {
            // Create FormData from object
            formData = new FormData();
            formData.append('name', staffData.name || '');
            formData.append('position', staffData.position || '');
            formData.append('gender', staffData.gender || '');
            formData.append('phone', staffData.phone || '');
            formData.append('email', staffData.email || '');
            formData.append('address', staffData.address || '');
            formData.append('salary', staffData.salary || ''); // ✅ Add salary field
            formData.append('admin_id', adminId);

            if (staffData.image) {
                formData.append('image', staffData.image);
            }
        }

        // ✅ Debug: Log the FormData contents
        console.log('Sending FormData:');
        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }

        const response = await fetch(`${API_URL}/staff`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${getAuthToken()}`,
                'Accept': 'application/json',
                // Don't set Content-Type when using FormData
            },
            body: formData
        });

        // ✅ Debug: Log response details
        console.log('Response status:', response.status);
        console.log('Response headers:', response.headers);

        // ✅ Check if response is ok
        if (!response.ok) {
            let errorMessage;
            try {
                const errorData = await response.json();
                console.error('Error response:', errorData);
                errorMessage = errorData.message || errorData.error || `HTTP error! status: ${response.status}`;
            } catch (parseError) {
                console.error('Could not parse error response:', parseError);
                errorMessage = `HTTP error! status: ${response.status}`;
            }
            throw new Error(errorMessage);
        }

        // ✅ Parse and return the response
        const result = await response.json();
        console.log('Success response:', result);
        return result;

    } catch (error) {
        console.error('Error adding staff:', error);

        // Provide more specific error messages
        if (error.name === 'TypeError' && error.message.includes('fetch')) {
            throw new Error('Network error - please check your connection');
        } else if (error.message.includes('401')) {
            throw new Error('Authentication failed - please login again');
        } else if (error.message.includes('422')) {
            throw new Error('Validation failed - please check your input');
        } else if (error.message.includes('500')) {
            throw new Error('Server error - please try again later');
        } else {
            throw error;
        }
    }
};

// Get All Staff
const getAllStaff = () => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.get(
        `${API_URL}/staff`,
        {
            headers: headers,
        }
    );

};
const getStaffById = (staffId) => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.get(
        `${API_URL}/staff/${staffId}`,
        {
            headers: headers,
        }
    );

};

// Function to get auth token (make sure this is also defined)
const getAuthToken = () => {
    // Return your authentication token
    return localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token');
    // OR return from wherever you store your token
};

const updateStaff = async (id, staffData) => {
    try {
        console.log('=== SERVICE DEBUG START ===');
        console.log('Updating staff with ID:', id);
        console.log('Original staffData received:', staffData);

        // Validate required fields
        const requiredFields = ['name', 'gender', 'phone', 'address'];
        const missingFields = requiredFields.filter(field => {
            return !staffData[field] || !staffData[field].toString().trim();
        });

        if (missingFields.length > 0) {
            throw new Error(`Missing required fields: ${missingFields.join(', ')}`);
        }

        // FIXED: Better salary processing with consistent handling
        let processedSalary = null;
        console.log('Raw salary value:', staffData.salary);
        console.log('Salary type:', typeof staffData.salary);
        
        if (staffData.salary !== null && staffData.salary !== undefined && staffData.salary !== '') {
            const salaryString = staffData.salary.toString().trim();
            if (salaryString && salaryString !== '0') {
                const salaryValue = parseFloat(salaryString);
                if (isNaN(salaryValue) || salaryValue < 0) {
                    throw new Error('Salary must be a valid positive number');
                }
                processedSalary = salaryValue;
            }
        }
        
        console.log('Processed salary:', processedSalary);

        // Check if image needs to be uploaded or removed
        const hasImage = staffData.image && typeof staffData.image === 'object';
        const removeImage = staffData.removeExistingImage;

        console.log('Has image:', hasImage);
        console.log('Remove image:', removeImage);

        if (hasImage || removeImage) {
            // Use FormData when handling file upload/removal
            const formData = new FormData();
            
            // FIXED: Laravel method spoofing for PUT request
            formData.append('_method', 'PUT');
            
            // Add required fields with proper validation
            formData.append('name', staffData.name.toString().trim());
            formData.append('gender', staffData.gender.toString().trim());
            formData.append('phone', staffData.phone.toString().trim());
            formData.append('address', staffData.address.toString().trim());
            
            // FIXED: Handle salary consistently in FormData
            if (processedSalary !== null) {
                formData.append('salary', processedSalary.toString());
                console.log('Salary appended to FormData:', processedSalary.toString());
            } else {
                formData.append('salary', '');
                console.log('Empty salary appended to FormData');
            }
            
            // Add optional fields with proper validation
            if (staffData.position && staffData.position.toString().trim()) {
                formData.append('position', staffData.position.toString().trim());
            } else {
                formData.append('position', '');
            }
            
            if (staffData.email && staffData.email.toString().trim()) {
                formData.append('email', staffData.email.toString().trim());
            } else {
                formData.append('email', '');
            }

            // Handle image upload
            if (hasImage) {
                formData.append('image', staffData.image);
                console.log('Image file added:', staffData.image.name);
            }

            // FIXED: Consistent image removal flag
            if (removeImage) {
                formData.append('remove_image', '1');
            }

            // Debug FormData contents
            console.log('=== FORMDATA CONTENTS ===');
            for (let [key, value] of formData.entries()) {
                console.log(`${key}:`, value instanceof File ? `File: ${value.name}` : value);
            }

            return await updateStaffWithFormData(id, formData);
        } else {
            // Use JSON if no image processing
            const jsonData = {
                name: staffData.name.toString().trim(),
                gender: staffData.gender.toString().trim(),
                phone: staffData.phone.toString().trim(),
                address: staffData.address.toString().trim()
            };
            
            // FIXED: Handle salary in JSON properly with consistent logic
            if (processedSalary !== null) {
                jsonData.salary = processedSalary;
            } else {
                jsonData.salary = null;
            }
            
            // Add optional fields with proper validation
            if (staffData.position && staffData.position.toString().trim()) {
                jsonData.position = staffData.position.toString().trim();
            }
            if (staffData.email && staffData.email.toString().trim()) {
                jsonData.email = staffData.email.toString().trim();
            }

            console.log('=== JSON DATA TO SEND ===');
            console.log(JSON.stringify(jsonData, null, 2));
            return await updateStaffWithJSON(id, jsonData);
        }

    } catch (error) {
        console.error('=== SERVICE ERROR ===');
        console.error('Error in updateStaff service:', error);
        console.error('Error response:', error.response?.data);
        throw error;
    }
};

// FIXED: Consistent JSON update method
const updateStaffWithJSON = async (id, staffData) => {
    // Create payload with consistent data handling
    const payload = {
        name: staffData.name || '',
        gender: staffData.gender || '',
        phone: staffData.phone || '',
        address: staffData.address || ''
    };

    // FIXED: Handle salary properly - don't convert to string for JSON
    if (staffData.salary !== null && staffData.salary !== undefined) {
        payload.salary = staffData.salary;
    } else {
        payload.salary = null;
    }

    // Add optional fields only if they have values
    if (staffData.position) {
        payload.position = staffData.position;
    }
    if (staffData.email) {
        payload.email = staffData.email;
    }

    console.log('JSON Payload being sent:', payload);

    const config = {
        timeout: 30000,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            // Add authentication headers if needed
            // 'Authorization': `Bearer ${getAuthToken()}`,
        }
    };

    try {
        const response = await axios.put(`${API_URL}/staff/${id}`, payload, config);
        console.log('JSON Update Success:', response.data);
        return response;
    } catch (error) {
        console.error('JSON Update failed:', error.response?.data || error.message);
        throw error;
    }
};

// FIXED: FormData Update method with proper Laravel handling
const updateStaffWithFormData = async (id, formData) => {
    console.log('FormData contents before sending:');
    for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, typeof value === 'object' ? `File: ${value.name || 'file'}` : value);
    }

    const config = {
        timeout: 30000,
        headers: {
            'Accept': 'application/json',
            // Don't set Content-Type for FormData - let browser set it with boundary
            // Add authentication headers if needed
            // 'Authorization': `Bearer ${getAuthToken()}`,
        }
    };

    try {
        // FIXED: Use POST with _method for Laravel compatibility (already added in main function)
        const response = await axios.post(`${API_URL}/staff/${id}`, formData, config);
        console.log('FormData Update Success:', response.data);
        return response;
    } catch (error) {
        console.error('FormData Update failed:', error.response?.data || error.message);
        
        // FIXED: Better error handling and fallback
        if (error.response?.status === 405) {
            console.log('Method not allowed, trying direct PUT...');
            
            // Remove _method and try direct PUT
            const newFormData = new FormData();
            for (let [key, value] of formData.entries()) {
                if (key !== '_method') {
                    newFormData.append(key, value);
                }
            }
            
            try {
                const putResponse = await axios.put(`${API_URL}/staff/${id}`, newFormData, config);
                console.log('Direct PUT Success:', putResponse.data);
                return putResponse;
            } catch (putError) {
                console.error('Direct PUT also failed:', putError.response?.data || putError.message);
                throw putError;
            }
        } else {
            throw error;
        }
    }
};




// Then use it like: `${CONFIG.API_BASE_URL}/staff/${staffId}`

// Delete Staff
const deleteStaffById = async (staffId) => {
    try {
        const response = await fetch(`${API_URL}/staff/${staffId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${getAuthToken()}`,
                'Content-Type': 'application/json',
            }
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error deleting staff:', error);
        throw error;
    }
};


const listAllDoctors = () => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.get(
        `${API_URL}/doctors`,
        {
            headers: headers,
        }
    );

};

const getDoctorById = (id) => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.get(
        `${API_URL}/doctors/${id}`,
        {
            headers: headers,
        }
    );
};

// Add this new method to your GeneralService
const updateDoctorWithFormData = async (id, formData) => {
    try {
        // Add method spoofing for Laravel
        formData.append('_method', 'PUT');

        // Log FormData contents for debugging
        console.log('FormData contents in service:');
        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }

        // Use POST method with method spoofing instead of PUT
        const config = {
            headers: {
                // Don't set Content-Type for FormData - browser will set multipart/form-data
            },
            timeout: 30000, // 30 seconds
        };

        const response = await axios.post(
            `${API_URL}/doctors/${id}`,
            formData,
            config
        );

        return response;

    } catch (error) {
        console.error('Error in updateDoctorWithFormData service:', error);
        console.error('Error response:', error.response?.data);
        throw error;
    }
};

// Or if you want to keep the existing method, replace it with this:
const updateDoctor = async (id, doctorData) => {
    try {
        const formData = new FormData();

        // Always add name (required field) - even if empty, let backend validate
        formData.append('name', doctorData.name ? doctorData.name.trim() : '');

        // Add other text fields - send them even if empty (will be handled by backend)
        formData.append('designation', doctorData.designation || '');
        formData.append('specialization', doctorData.specialization || '');
        formData.append('degrees', doctorData.degrees || '');

        if (doctorData.gender) {
            formData.append('gender', doctorData.gender);
        }

        // Add image if present
        if (doctorData.image && typeof doctorData.image === 'object') {
            formData.append('image', doctorData.image);
        }

        // Add flag to remove existing image
        if (doctorData.removeExistingImage) {
            formData.append('removeExistingImage', 'true');
        }

        // Log FormData contents for debugging
        console.log('FormData contents:');
        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }

        // Don't set Content-Type header manually for FormData
        const config = {
            timeout: 30000, // 30 seconds
        };

        const response = await axios.put(
            `${API_URL}/doctors/${id}`,
            formData,
            config
        );

        return response;

    } catch (error) {
        console.error('Error in updateDoctor service:', error);
        console.error('Error response:', error.response?.data);
        throw error;
    }
};

const handleEditClick = (doctorId) => {
    console.log("Edit clicked for doctor ID:", doctorId);
    // console.log("Doctor object:", doctors.find(d => d.id === doctorId));

    if (!doctorId) {
        console.error("Doctor ID is missing!");
        alert("Doctor ID is missing. Cannot edit.");
        return;
    }

    // Check if the route exists
    console.log("Navigating to:", `/edit-doctor/${doctorId}`);

    try {
        Navigate(`/edit-doctor/${doctorId}`);
    } catch (error) {
        console.error("Navigation error:", error);
        alert("Failed to navigate to edit page.");
    }
};

const dashboardCounters = () => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.get(
        `${API_URL}/dashboard-counters`,
        {
            headers: headers,
        }
    );
    
};

const listOpenHours = () => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.get(
        `${API_URL}/hour`,
        {
            headers: headers,
        }
    );

};

 const addOpeningHour = (values) => {
        const headers = {
            "Content-Type": "application/json",
        };

        console.log("Sending add opening hour request to:", `${API_URL}/hour`);
        console.log("Hour data:", values);

        return axios.post(
            `${API_URL}/hour`,
            {
                opening_hours: [
                    {
                        day: values.day,
                        open_time: values.open_time || '',
                        close_time: values.close_time || '',
                        is_closed: values.is_closed,
                        emergency_only: values.emergency_only
                    }
                ]
            },
            {
                headers: headers,
            }
        ).then(response => {
            console.log("Add opening hour response received:", response);
            return {
                success: true,
                message: response.data.message || 'Opening hour added successfully',
                data: response.data
            };
        }).catch(error => {
            console.error("Add opening hour error:", error);
            return {
                success: false,
                message: error.response?.data?.message || error.message || 'Failed to add opening hour',
                error: error
            };
        });
    }

 const deleteOpenHoursById = () => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.delete(
        `${API_URL}/hour`,
        {
            headers: headers,
        }
    );
};

 const getAppointments = () => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.get(
        `${API_URL}/appointments`,
        {
            headers: headers,
        }
    );
};
 const updateAppointmentStatus = (appointmentId, status) => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.put(
        `${API_URL}/appointments/${appointmentId}/${status}`,
        {
            headers: headers,
        }
    );
};

 const getPatientTokens = () => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.get(
        `${API_URL}/patient-tokens`,
        {
            headers: headers,
        }
    );
};

const getNotifications = (unreadOnly = false, page = 1, limit = 10) => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.get(
        `${API_URL}/notifications`,
        {
            params: { 
                unread_only: unreadOnly,
                page: page,
                limit: limit
            },
            headers: headers,
        }
    );
};

// Get unread notification count
const getUnreadCount = () => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.get(
        `${API_URL}/unread-count`,
        {
            headers: headers,
        }
    );
};

// Get recent notifications for dropdown
const getRecentNotifications = (limit = 5) => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.get(
        `${API_URL}//recent`,
        {
            params: { limit },
            headers: headers,
        }
    );
};

// Mark specific notification as read
const markAsRead = (notificationId) => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.post(
        `${API_URL}/mark-read/${notificationId}`,
        {},
        {
            headers: headers,
        }
    );
};

// Mark all notifications as read
const markAllAsRead = () => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.post(
        `${API_URL}/read-all`,
        {},
        {
            headers: headers,
        }
    );
};

// Delete notification
const deleteNotification = (notificationId) => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.delete(
        `${API_URL}/notifications/${notificationId}`,
        {
            headers: headers,
        }
    );
};

// Delete all read notifications
const deleteAllReadNotifications = () => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.delete(
        `${API_URL}/notifications/delete-read`,
        {
            headers: headers,
        }
    );
};

// Send test notification (for development)
const sendTestNotification = (userId, type = 'test') => {
    const headers = {
        "Content-Type": "application/json",
    };
    return axios.post(
        `${API_URL}/notifications/send-test`,
        {
            user_id: userId,
            type: type
        },
        {
            headers: headers,
        }
    );
};

const GeneralService = {
    dashboardCounters,login, getContactMessages, addDoctor, deleteDoctor,listAllDoctors,getDoctorById,updateDoctorWithFormData,updateDoctor,handleEditClick, addStaff, getAllStaff,
     getStaffById, updateStaff, deleteStaffById ,listOpenHours,addOpeningHour,deleteOpenHoursById,getAppointments,updateAppointmentStatus,getPatientTokens,
     getNotifications,getUnreadCount,getRecentNotifications,markAsRead,markAllAsRead,deleteNotification,deleteAllReadNotifications,sendTestNotification,
};
export default GeneralService;
